<div *ngIf="spinnerIsShown">
    <div class="text-center mt-2">
        <h4 class="text-primary">Loading Document...</h4>
        <div class="spinner-border text-primary avatar-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</div>

<ngx-extended-pdf-viewer *ngIf="pdfSrc" style="text-align: center; width: {{widthPx}}px; border: 1px solid black;" [useBrowserLocale]="true" [zoom]="'page-width'" 
[theme]="'dark'" [height]="'500px'" [showDrawEditor]="false" [showTextEditor]="false" [showStampEditor]="false" [src]="pdfSrc" [showOpenFileButton]="false" [showSecondaryToolbarButton]="false"
    >
</ngx-extended-pdf-viewer>

<div *ngIf="showNoDocument">
    <div class="text-center" style="text-align: center; width: {{widthPx}}px; border: 1px solid black;">
        <h4 class="text-danger" style="padding-top: 0.5rem;"> Document Failed to Load</h4>
    </div>
</div>